import { Reducer } from 'redux';
import {
  DELETE_ITEM_PRICE,
  GET_ITEM_PRICE,
  GET_ITEM_PRICE_LIST,
  ItemPriceActionTypes,
  ItemPriceState,
  POST_ITEM_PRICE,
  PUT_ITEM_PRICE,
  UPDATE_ITEM_PRICE_FILTERS
} from '../types/itemprice.types';

const initialState: ItemPriceState = {
  itemPrices: [],
  selectedItemPrice: null,
  postSuccess: null,
  lastFetch: null,
  totalElements: 1,
  totalPages: 0,
  filters: null
};

export const itemPriceReducer: Reducer<ItemPriceState> = (
  state: ItemPriceState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as ItemPriceActionTypes).type) {
    case GET_ITEM_PRICE_LIST:
      return {
        ...state,
        itemPrices: action.payload.page.content,
        selectedItemPrice: null,
        postSuccess: null,
        totalElements: action.payload.page.totalElements,
        totalPages: action.payload.page.totalPages,
        lastFetch: timeOfAction
      };
    case GET_ITEM_PRICE:
      return {
        ...state,
        postSuccess: null,
        selectedItemPrice: action.payload.selectedItemPrice,
        lastFetch: timeOfAction
      };
    case POST_ITEM_PRICE:
      return {
        ...state,
        postSuccess: true,
        selectedItemPrice: action.payload.newItemPrice,
        lastFetch: timeOfAction
      };
    case PUT_ITEM_PRICE:
      return {
        ...state,
        selectedItemPrice: action.payload.selectedItemPrice,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_ITEM_PRICE:
      return {
        ...state,
        selectedItemPrice: null,
        lastFetch: timeOfAction
      };
    case UPDATE_ITEM_PRICE_FILTERS:
      return {
        ...state,
        filters: action.payload.filters
      };
    default:
      return state;
  }
};
